import { render } from "./StakeholderManagement.vue?vue&type=template&id=29cebb94"
import script from "./StakeholderManagement.vue?vue&type=script&lang=js"
export * from "./StakeholderManagement.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__